import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;


const IntelligenceDashboardService = {
  getList: async () => {
    const response = await apiService.get("/dashboardmenus");
    
    return response.data;
  },

  getbyId: async (id) => {
    const response = await apiService.get(`/countrywiseintellsection/by-country/${id}`);
    return response.data;
  },

  compare: async (payload) => {
    const response = await apiService.post("/countrywiseintellsection/compare-requirements", payload);
    return response.data;
  },
};

export default IntelligenceDashboardService;
